export default function StatsSection() {
  return (
    <div className="py-16 bg-gradient-to-r from-blue-600 to-cyan-600 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 text-center">
          <div>
            <div className="text-4xl font-bold mb-2">500+</div>
            <div className="text-blue-100">활성 시스템</div>
          </div>
          <div>
            <div className="text-4xl font-bold mb-2">99.9%</div>
            <div className="text-blue-100">가동 시간 보장</div>
          </div>
          <div>
            <div className="text-4xl font-bold mb-2">5천만+</div>
            <div className="text-blue-100">리터 모니터링</div>
          </div>
          <div>
            <div className="text-4xl font-bold mb-2">24/7</div>
            <div className="text-blue-100">지원 가능</div>
          </div>
        </div>
      </div>
    </div>
  );
}
